import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import Table from "../../../../common/components/table";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectCurrent } from "../../../../redux/settings/selectors";
import { campaigns } from "../../../../redux/campaigns/action";
import PageLoader from "../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import TabContainer from "../../../../common/components/tab/containers/tab.containers";
import { emailCampaigns } from "../../../../redux/email-campaigns/action";
import { selectEmailCampaignsListItems } from "../../../../redux/email-campaigns/selector";
import { selectSmsCampaignsListItems } from "../../../../redux/sms-campaigns/selector";
import { smsCampaigns } from "../../../../redux/sms-campaigns/action";
import SmsMarketingPlanComponent from "../components/sms/sms-marketing-plan.component";
import { PlanSMSTemplateInfoComponent } from "../components/sms/sms-marketing-plans.component";

const PartnerCampaigns = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const itemsData = useSelector(selectEmailCampaignsListItems)
    const smsItemsData = useSelector(selectSmsCampaignsListItems)
    
    const [
        columnDefsEmail,
        setColumnDefsEmail,
      ] = useState({});
      const createColumnDefsEmail: any = () => {
        setColumnDefsEmail([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name',isEdit: true },
          // { field: 'CampaignTypeId', headerName: 'Type', cellRenderer: 'campaignTypeRendererComponent', cellRendererParams: { campaignTypes: libraries.CampaignType } },
          // { field: 'FrequencyId', headerName: 'Frequency', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraries.CampaignFrequency } },
          // { field: 'CampaignStatusId', headerName: 'Status', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraries.CampaignStatus } },
          { field: 'StartDate', headerName: 'Start Date', isDateValueFormat:true },
          { field: 'EndDate', headerName: 'End Date', isDateValueFormat:true}
         
        ]);
      }

  const handleAdd=()=>{
    navigate(`${0}`)
  }

  const handleEdit=(data: any)=>{  
    navigate(`${data?.Id}`)
  }

  const fetchSmsCampaigns = async () => {
  await dispatch(smsCampaigns.resetAction({ actionType: 'list' }));
  await dispatch(smsCampaigns.list({
    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/sms-campaigns/list`,
    entity: 'smsCampaigns',
    jsonData: {
      PageNumber: pageData,
      PageSize: pageSize,
      SortField: 'Id',
      SortOrder: 'desc',
    }
  }));
};


  const fetchCampaigns=()=>{

    dispatch(campaigns.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaigns/list`,entity:'campaigns',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",

    }}))
  
  }

  const fetchEmailCampaigns=async ()=>{
    await dispatch(emailCampaigns.resetAction({ actionType: 'list' }));
   await  dispatch(emailCampaigns.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/email-campaigns/list`,entity:'emailCampaigns',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",

    }}))
  
  }
  useEffect(() => {

      createColumnDefsEmail()
      // fetchCampaigns()
      fetchEmailCampaigns();
      fetchSmsCampaigns();
  }, [pageData,pageSize])

  useEffect(() => {
    console.log('itemsData', itemsData)
  }, [itemsData]);

  const tabItems = [
    {
      id: 1,
      title: 'Email',
      component: <>
      <Table 
          columnData={columnDefsEmail} 
          rowData={itemsData?.result?.items} 
          setPageData={setPageData} 
          setPageSize={setPageSize}
          paginationData={itemsData?.result?.pagination} 
          onEdit={handleEdit}
          headingName="Campaigns" 
        />
      </>,
      isVisible: true,
    },
    {
      id: 2,
      title: 'SMS',
      component: <>
        <PlanSMSTemplateInfoComponent 
         columnData={columnDefsEmail} 
      rowData={smsItemsData?.result?.items} 
      setPageData={setPageData} 
      setPageSize={setPageSize}
      paginationData={smsItemsData?.result?.pagination} 
      onEdit={handleEdit} 
      headingName="SMS Campaigns" 
        /></>,
      
      isVisible: true,
    },
    // {
    //   id: 3,
    //   title: 'Whatsapp',
    //   component: <>Whatsapp Campaign Working on process</>,
    //   isVisible: true,
    // },
  //   {
  //     id: 4,
  //     title: 'Facebook',
  //     component: <>Facebook Campaign</>,
  //     isVisible: true,
  // },
  ]

  return (
    <>
      {itemsData?.isLoading ?
        <PageLoader /> :
        // <Table 
        //   columnData={columnDefs} 
        //   rowData={itemsData?.result?.items} 
        //   setPageData={setPageData} 
        //   setPageSize={setPageSize}
        //   paginationData={itemsData?.result?.pagination} 
        //   onEdit={handleEdit} 
        //   onDelete={handleDelete} 
        //   additionButtons={additionButtons} 
        //   headingName="Campaigns" 
        // />
        <TabContainer tabItems={tabItems} />
      }
    </>
  );
};

export default PartnerCampaigns;


